import { useMarkAppointmentAsNoShowMutation } from "../../../../../../../api/appointments/useMarkAppointmentAsNoShowMutation";
import { uiNotification } from "../../../../../../../services/UINotificationService";
import { useContext } from "../context";
import { NOTIFICATION_TYPE } from "../config";
import { useAppointmentNoShowNotificationQuery } from "../../../../../../../api/appointments/useAppointmentNoShowNotificationQuery";
import { extractApiError } from "../../../../../../../utilities/api";
import { useAppTranslation } from "../../../../../../../i18n/useAppTranslation";

export function useMarkNoShow() {
  const { appointment, onClose, refetchAppointments } = useContext();
  const { tCommon: t } = useAppTranslation.Common();

  const { data: notification } = useAppointmentNoShowNotificationQuery({
    appointmentId: appointment.id,
  });

  const { mutateAsync, isLoading } = useMarkAppointmentAsNoShowMutation({
    onError: (error) => {
      const message = extractApiError(error);
      uiNotification.error(
        t(
          `error.${message}`,
          "Failed to mark appointment as no-show. Please try again later.",
        ),
      );
    },
    onSuccess: () => {
      uiNotification.success(
        "Appointment has been successfully marked as no-show.",
      );
      onClose();
      refetchAppointments();
    },
  });

  return {
    initiate: ({ charge, notificationType, notificationBody }) => {
      return mutateAsync({
        appointmentId: appointment.id,
        charge: charge || false,
        notification: {
          type: notificationType || NOTIFICATION_TYPE.emailAndSms,
          body: notificationBody || notification?.bodyEmail,
          subject: notification?.subject,
          bodySms: notification?.bodySms,
          successMessage: notification?.successMessage,
        },
      });
    },
    isLoading,
  };
}
